import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-loanPostOperatorLog/loanPostOperatorLog/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-loanPostOperatorLog/loanPostOperatorLog/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-loanPostOperatorLog/loanPostOperatorLog/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-loanPostOperatorLog/loanPostOperatorLog/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-loanPostOperatorLog/loanPostOperatorLog/submit',
    method: 'post',
    data: row
  })
}


//logPage
export const logPage = (params) => {
  return request({
    url: '/api/blade-loanPostOperatorLog/loanPostOperatorLog/logPage',
    method: 'post',
    data: {
      ...params,
    }
  })
}
